import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

export interface SecurityQuestionInfo {
  securityQuestions: SecurityQuestion[]
  securityQuestionId: number
  securityQuestionCustom: string
  securityQuestionAnswer: string
}

export interface SecurityQuestion {
  securityQuestionId: number
  securityQuestion: string
}

// GET /billing_address
export const securityQuestion = async () => {
  const response = await new Request().get('/ajax/security_question_info')
  return Util.Obj.keysToCamel(response.data.security_question_info) as SecurityQuestionInfo
}
